import React from "react";
import "./AdminRolesCards.css";
import Checkbox from "@mui/material/Checkbox";

export const AdminRolesCards = ({
  _id,
  label,
  setSelectedPermissions,
  selectedPermissions = [],
  descp,
  checked,
  onChange,
}) => {
  const isControlled = typeof checked === "boolean";
  const isChecked = isControlled
    ? checked
    : selectedPermissions.some(
        (permissionId) => String(permissionId) === String(_id)
      );

  const handleChange = () => {
    if (isControlled) {
      onChange?.(!isChecked);
      return;
    }

    if (isChecked) {
      setSelectedPermissions(
        selectedPermissions.filter(
          (value) => String(value) !== String(_id)
        )
      );
      return;
    }

    setSelectedPermissions([...selectedPermissions, _id]);
  };

  return (
    <div className="adminRolesCards">
      <div className="adminRolesCards__head">
        <Checkbox
          checked={isChecked}
          sx={{ "& .MuiSvgIcon-root": { fontSize: 18 } }}
          onChange={handleChange}
        />
        <h4>{label}</h4>
      </div>
      <div className="seprator"></div>
      <h5 className="ftwt__r">{descp}</h5>
    </div>
  );
};
